import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M className={className} initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }} transition={{ duration: 1, ease: EASE, delay }}>
      {children}
    </M>
  );
};

const lineV = { hide: { y: "110%" }, show: { y: 0 } };

export const MaskLines = ({ lines, className = "", delay = 0, inView = false }) => (
  <motion.span className={`block ${className}`} initial="hide"
    {...(inView ? { whileInView: "show", viewport: { once: true, amount: 0.1 } } : { animate: "show" })}>
    {lines.map((l, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span className="block" variants={lineV} transition={{ duration: 1.15, ease: EASE, delay: delay + i * 0.12 }}>
          {l}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const Eyebrow = ({ children, light = false }) => (
  <span className={`inline-flex items-center gap-3 text-[11px] tracking-[0.3em] uppercase font-medium ${light ? "text-[#E0C48C]" : "text-[#8A6420]"}`}>
    <span className={`h-px w-8 ${light ? "bg-[#E0C48C]" : "bg-[#8A6420]"}`} />{children}
  </span>
);
